<template>
  <v-dialog v-model="dialog" persistent max-width="500px">
    <v-card>
      <!-------------------------------------------TITLE------------------------------------------->
      <v-card-title class="redColor d-flex text-white">
        <span v-if="edit == true" class="headline">
          {{ $t("institutions.form.edit_institution") }}
        </span>
        <span v-if="edit == false" class="headline">
          {{ $t("institutions.form.create_institution") }}
        </span>
        <v-spacer />
        <v-btn variant="outlined" icon color="white" @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <!------------------------------------------------------------------------------------------->
      <v-card-text>
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-container grid-list-md>
            <v-row wrap>
              <!---------------------------------------TITLE--------------------------------------->
              <v-col xs="12" md="12" lg="12">
                <v-text-field
                  v-model="institution.title"
                  :rules="rules.requiredLetters"
                  :label="$t('institutions.form.title')"
                  color="red-darken-1"
                  prepend-icon="mdi-domain"
                />
              </v-col>
              <!--------------------------------------ADDRESS-------------------------------------->
              <v-col xs="12" md="12" lg="12">
                <v-text-field
                  v-model="institution.address"
                  :rules="rules.requiredLetters"
                  :label="$t('institutions.form.address')"
                  color="red-darken-1"
                  prepend-icon="mdi-list-box-outline"
                />
              </v-col>
              <!------------------------------------UPLOAD LOGO------------------------------------>
              <v-col xs="12" md="12" lg="12">
                <label style="padding-right: 10px">{{
                  $t("institutions.form.upload_logo")
                }}</label>
                <v-tooltip bottom>
                  <template #activator="{ on, attrs }">
                    <v-icon v-bind="attrs" small v-on="on"> info </v-icon>
                  </template>
                  <span>72 x 72 {{ $t("institutions.form.preferred") }}</span>
                </v-tooltip>
                <br />
                <input
                  ref="logo"
                  :style="{ color: !validLogo ? '#ff5252' : '' }"
                  type="file"
                  accept="image/*"
                  :rules="false"
                  @change="onInput"
                />
              </v-col>
              <!---------------------------------------STATE--------------------------------------->
              <v-col xs="6" md="6" lg="6">
                <v-select
                  v-model="state"
                  :rules="rules.required"
                  :items="states"
                  :loading="loadingState"
                  :label="$t('institutions.form.state')"
                  color="red-darken-1"
                  item-title="name"
                  item-value="name"
                  prepend-icon="mdi-earth"
                  return-object
                />
              </v-col>
              <!---------------------------------------CITY---------------------------------------->
              <v-col xs="6" md="6" lg="6">
                <v-select
                  v-model="institution.city"
                  :rules="rules.required"
                  :items="cities"
                  :loading="loadingCity"
                  :label="$t('institutions.form.city')"
                  color="red-darken-1"
                  item-title="name"
                  item-value="name"
                  prepend-icon="mdi-city"
                />
              </v-col>
              <!---------------------------------------PHONE--------------------------------------->
              <v-col xs="12" md="12" lg="12">
                <v-text-field
                  v-model="institution.phone"
                  :rules="rules.requiredNumbers"
                  :label="$t('institutions.form.phone')"
                  color="red-darken-1"
                  prepend-icon="mdi-phone"
                  type="number"
                />
              </v-col>
              <!--------------------------------------WEBSITE-------------------------------------->
              <v-col xs="12" md="12" lg="12">
                <v-text-field
                  v-model="institution.website"
                  :rules="rules.requiredLetters"
                  :label="$t('institutions.form.website')"
                  color="red-darken-1"
                  prepend-icon="mdi-web"
                />
              </v-col>
              <!-------------------------------------LEKOSHOP-------------------------------------->
              <v-col xs="12" md="12" lg="12">
                <v-text-field
                  v-model="institution.shop"
                  :label="$t('institutions.table.shop')"
                  color="red-darken-1"
                  prepend-icon="mdi-store"
                />
              </v-col>
              <!---------------------------------------Email--------------------------------------->
              <v-col xs="12" md="12" lg="12">
                <v-text-field
                  v-model="institution.email"
                  :rules="rules.email"
                  :label="$t('institutions.form.email')"
                  color="red-darken-1"
                  prepend-icon="mdi-email"
                  @input="emailError = null"
                />
              </v-col>
              <!------------------------------------REFERRED BY------------------------------------->
              <v-col
                v-if="$store.getters.role === 'SuperAdmin' || $store.getters.role == 'LekoAdmin'"
                xs="12"
                md="12"
                lg="12"
              >
                <v-autocomplete
                  v-model="institution.referred_by"
                  :items="filteredInstitutions"
                  :loading="loadingInstitutions"
                  :label="$t('institutions.form.referred_by')"
                  color="red-darken-1"
                  item-title="title"
                  item-value="_id"
                  prepend-icon="mdi-account-arrow-right-outline"
                  clearable
                  autocomplete="off"
                />
              </v-col>
              <!----------------------------------HAS UNPAID INVOICES------------------------------------>
              <v-col
                v-if="
                  $store.getters.role === 'SuperAdmin' ||
                  $store.getters.role === 'LekoAdmin'
                "
                xs="12"
              >
                <v-switch
                  v-model="institution.hasUnpaidInvoices"
                  :label="$t('hasUnpaidInvoices')"
                  color="red darken-1"
                  prepend-icon="poll"
                />
              </v-col>
              <!--------------------------------------STATUS--------------------------------------->
              <v-col xs="12" md="12" lg="12">
                <v-switch
                  v-model="institution.user_status"
                  :label="$t('institutions.form.user_status')"
                  color="red-darken-1"
                  prepend-icon="mdi-poll"
                />
              </v-col>
              <!------------------------------EXPORT EBAY MULTIBREVES------------------------------>
              <!-- HIDE MULTIBREVES -->
              <!-- <v-col
                v-if="$store.getters.role === 'SuperAdmin'"
                xs="12"
              >
                <v-switch
                  v-model="institution.export_ebay"
                  :label="$t('institutions.table.exportEbay')"
                  color="red-darken-1"
                  prepend-icon="mdi-poll"
                />
              </v-col> -->
              <!---------------------------------EXPORT EBAY LEKO---------------------------------->
              <!-- <v-col xs="12" md="12" lg="12">
                <v-switch
                  v-model="institution.export_ebay_leko"
                  :label="$t('institutions.table.exportEbayLeko')"
                  color="red-darken-1"
                  prepend-icon="mdi-poll"
                />
              </v-col> -->
              <!----------------------------------EXPORT PARTS------------------------------------->
              <v-col v-if="$store.getters.role === 'SuperAdmin'" xs="12">
                <v-switch
                  v-model="institution.export_parts"
                  :label="$t('institutions.table.exportParts')"
                  color="red-darken-1"
                  prepend-icon="mdi-poll"
                />
              </v-col>
              <!--------------------------------EXPORT TEMPORARY PARTS----------------------------->
              <v-col xs="12" md="12" lg="12">
                <v-switch
                  v-model="institution.export_temporary_parts"
                  :label="$t('institutions.table.exportTempParts')"
                  color="red-darken-1"
                  prepend-icon="mdi-poll"
                />
              </v-col>
              <!----------------------------------EXPORT SALES------------------------------------->
              <v-col xs="12" md="12" lg="12">
                <v-switch
                  v-model="institution.export_sales"
                  :label="$t('institutions.table.exportSales')"
                  color="red-darken-1"
                  prepend-icon="mdi-poll"
                />
              </v-col>
              <!----------------------------------EXPORT STATS------------------------------------->
              <v-col xs="12" md="12" lg="12">
                <v-switch
                  v-model="institution.stats"
                  :label="$t('institutions.form.stats')"
                  :disabled="!institution.email"
                  color="red-darken-1"
                  prepend-icon="mdi-poll"
                />
              </v-col>
              <!----------------------------------DISPLAY SHOP------------------------------------->
              <v-col v-if="$store.getters.role === 'SuperAdmin'" xs="12">
                <v-switch
                  v-model="institution.display_shop"
                  :label="$t('institutions.form.displayShop')"
                  color="red-darken-1"
                  prepend-icon="mdi-poll"
                />
              </v-col>
              <!---------------------------------TRANSFER CARS------------------------------------->
              <v-col xs="12" md="12" lg="12">
                <v-switch
                  v-model="institution.transfer_cars"
                  :label="$t('institutions.form.transferCars')"
                  color="red-darken-1"
                  prepend-icon="mdi-poll"
                />
              </v-col>
              <!------------------------------------INFOCAR CAD------------------------------------>
              <v-col xs="12" md="12" lg="12">
                <v-switch
                  v-if="institution && institution.preferences"
                  v-model="institution.preferences.displayFeatures.infoCarCad"
                  :label="$t('institutions.form.infoCarCad')"
                  color="red-darken-1"
                  prepend-icon="mdi-poll"
                />
              </v-col>
              <!---------------------------------------TYPE---------------------------------------->
              <v-col xs="12" md="12" lg="12">
                <v-text-field
                  v-model="institution.type"
                  :rules="rules.requiredLetters"
                  :label="$t('institutions.form.type')"
                  color="red-darken-1"
                  prepend-icon="mdi-domain"
                />
              </v-col>
              <!---------------------------FISCAL INFORMATION--------------------------------------->
              <v-col xs="12" md="12" lg="12">
                <div class="text-subtitle-2 font-weight-bold mb-1">
                  {{ $t("institutions.form.fiscal_information") }}
                </div>
              </v-col>
              <v-col xs="12" md="12" lg="12">
                <v-text-field
                  v-model="institution.fiscalInformation.companyName"
                  :label="$t('institutions.form.company_name')"
                  color="red-darken-1"
                  prepend-icon="mdi-domain"
                />
              </v-col>
              <v-col xs="12" md="12" lg="12">
                <v-text-field
                  v-model="institution.fiscalInformation.legalAddress"
                  :label="$t('institutions.form.legal_address')"
                  color="red-darken-1"
                  prepend-icon="mdi-map-marker-outline"
                />
              </v-col>
              <v-col xs="12" md="12" lg="12">
                <v-text-field
                  v-model="institution.fiscalInformation.vatNumber"
                  :label="$t('institutions.form.vat_number')"
                  color="red-darken-1"
                  prepend-icon="mdi-identifier"
                />
              </v-col>
              <v-col xs="12" md="12" lg="12">
                <v-text-field
                  v-model="institution.fiscalInformation.taxCode"
                  :label="$t('institutions.form.tax_code')"
                  color="red-darken-1"
                  prepend-icon="mdi-card-account-details-outline"
                />
              </v-col>
              <v-col xs="12" md="12" lg="12">
                <v-text-field
                  v-model="institution.fiscalInformation.legalRepresentative"
                  :label="$t('institutions.form.legal_representative')"
                  color="red-darken-1"
                  prepend-icon="mdi-account-tie"
                />
              </v-col>
              <v-col xs="12" md="12" lg="12">
                <v-text-field
                  v-model="institution.fiscalInformation.uniqueCode"
                  :label="$t('institutions.form.unique_code')"
                  color="red-darken-1"
                  prepend-icon="mdi-barcode"
                />
              </v-col>
              <!---------------------------------------PARTS--------------------------------------->
              <v-col xs="12" md="12" lg="12">
                <v-row v-if="institution.parts" row align-center wrap>
                  <v-col xs="12" sm="4" md="4" lg="4">
                    <span class="subheading grey--text text--darken-1">
                      {{ $t("institutions.form.type_of_parts") }}:
                    </span>
                  </v-col>
                  <v-col>
                    <v-checkbox
                      v-model="institution.parts.new"
                      :label="$t('institutions.form.new')"
                      color="primary"
                    />
                  </v-col>
                  <v-col>
                    <v-checkbox
                      v-model="institution.parts.used"
                      :label="$t('institutions.form.used')"
                      color="primary"
                    />
                  </v-col>
                </v-row>
              </v-col>
              <!--------------------------------------PLATES--------------------------------------->
              <v-col xs="6" md="6" lg="6">
                <v-text-field
                  v-model="institution.plates.used"
                  disabled
                  :label="$t('institutions.form.total_plates')"
                  type="number"
                  color="red-darken-1"
                />
              </v-col>
              <v-col xs="6" md="6" lg="6">
                <v-text-field
                  v-model="institution.plates.remaining"
                  :label="$t('institutions.form.remaining_plates')"
                  type="number"
                  step="1"
                  min="0"
                  oninput="validity.valid||(value='');"
                  color="red-darken-1"
                />
              </v-col>
              <!----------------------------------------------------------------------------------->
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>
      <!------------------------------------------ACTIONS------------------------------------------>
      <v-card-actions class="flex-column align-end pa-4 ga-2">
        <div v-if="emailError" class="text-red-darken-1 text-body-2 w-100 text-center">
        <v-alert
          type="error"
          variant="tonal"
          class="mt-3"
          icon="mdi-home-alert"
        >
          {{ emailError }}
          </v-alert>
        </div>
        <div class="d-flex ga-2">
          <v-btn color="red-darken-1" variant="outlined" @click="close">
            {{ $t("institutions.form.close") }}
          </v-btn>
          <v-btn
            :disabled="!valid || !validLogo"
            :loading="loading"
            color="green-darken-1"
            variant="outlined"
            @click="save"
          >
            {{ $t("institutions.form.save") }}
          </v-btn>
        </div>
      </v-card-actions>
      <!------------------------------------------------------------------------------------------->
    </v-card>
  </v-dialog>
</template>

<script>
import postRequest from "../../api/postRequest";
import getRequest from "../../api/getRequest";

function dataURLtoBlob(dataUrl) {
  // convert base64 to raw binary data held in a string
  const byteString = atob(dataUrl.split(",")[1]);
  // separate out the mime component
  const mimeString = dataUrl.split(",")[0].split(":")[1].split(";")[0];
  // write the bytes of the string to an ArrayBuffer
  const ab = new ArrayBuffer(byteString.length);
  // create a view into the buffer
  const ia = new Uint8Array(ab);
  // set the bytes of the buffer to the correct values
  for (let i = 0; i < byteString.length; i += 1) {
    ia[i] = byteString.charCodeAt(i);
  }
  // write the ArrayBuffer to a blob, and you're done
  return new Blob([ab], { type: mimeString });
}

export default {
  data: () => ({
    valid: false,
    edit: null,
    logo: null,
    dialog: false,
    loading: false,
    loadingState: false,
    loadingCity: false,
    emailError: null,
    rules: {
      requiredLetters: [
        (v) => !!v || "Please fill this field",
        (v) => /[A-Za-z]/.test(v) || "Only letters are allowed",
      ],
      requiredNumbers: [
        (v) => !!v || "Please fill this field",
        (v) => /[0-9]/.test(v) || "Only numbers are allowed",
      ],
      email: [
        (v) => !!v || "Please fill this field",
        (v) => /.+@.+/.test(v) || "E-mail must be valid",
      ],
    },
    institution: {
      plates: { used: 0, remaining: 0 },
      fiscalInformation: {
        companyName: null,
        legalAddress: null,
        vatNumber: null,
        taxCode: null,
        legalRepresentative: null,
        uniqueCode: null,
      },
    },
    states: [],
    state: null,
    cities: [],
    institutions: [],
    loadingInstitutions: false,
  }),
  computed: {
    validLogo() {
      if (this.edit === true) return true;
      else if (this.edit === false && this.logo !== null) return true;
      return false;
    },
    filteredInstitutions() {
      return this.institutions.filter((i) => i._id !== this.institution._id);
    },
  },
  watch: {
    state(value) {
      if (value) {
        this.institution.state = value.name;
        this.getCities(value._id);
      }
    },
  },
  methods: {
    open(edit, data) {
      this.edit = edit;
      /*
       * Add the plates object if it doesn't exist, so it won't throw an error when creating a
       * new institution.
       */
      if (!data.plates) data.plates = { used: 0, remaining: 0 }; // eslint-disable-line no-param-reassign, max-len
      if (!data.fiscalInformation) {
        // eslint-disable-next-line no-param-reassign
        data.fiscalInformation = {
          companyName: null,
          legalAddress: null,
          vatNumber: null,
          taxCode: null,
          legalRepresentative: null,
          uniqueCode: null,
        };
      } else if (data.fiscalInformation.uniqueCode === undefined) {
        // eslint-disable-next-line no-param-reassign
        data.fiscalInformation.uniqueCode = null;
      }
      this.institution = data;
      this.dialog = true;
      this.getStates();
      if (this.$store.getters.role === 'SuperAdmin' || this.$store.getters.role === 'LekoAdmin') this.getInstitutions();
    },
    close() {
      this.institution = {
        plates: { used: 0, remaining: 0 },
        fiscalInformation: {
          companyName: null,
          legalAddress: null,
          vatNumber: null,
          taxCode: null,
          legalRepresentative: null,
          uniqueCode: null,
        },
      };
      this.states = [];
      this.state = null;
      this.cities = [];
      this.institutions = [];
      this.logo = null;
      this.dialog = false;
      this.loading = false;
      this.emailError = null;
      this.$nextTick(() => {
        if (this.$refs.logo) {
          this.$refs.logo.value = "";
        }
      });
      // this.$emit('close');
    },
    onInput(input) {
      const { files } = input.target;
      if (files && files.length > 0) {
        const { type } = files[0];
        const extension = type.split("/")[1]; // eslint-disable-line prefer-destructuring
        const fileReader = new FileReader();
        fileReader.readAsDataURL(files[0]);
        fileReader.addEventListener("load", () => {
          const dataUrl = fileReader.result;
          this.logo = { blob: dataURLtoBlob(dataUrl), extension };
        });
      }
    },
    getStates() {
      this.loadingState = true;
      getRequest("/state")
        .then((response) => {
          this.states = response.states;
          this.loadingState = false;
          if (this.institution.state) {
            // select institution's state
            this.states.forEach((state) => {
              if (state.name === this.institution.state) this.state = state;
            });
          }
        })
        .catch(() => {
          this.loadingState = false;
        });
    },
    getCities(id) {
      this.loadingCity = true;
      getRequest("/city", `state_id=${id}`)
        .then((response) => {
          this.cities = response.cities;
          this.loadingCity = false;
        })
        .catch(() => {
          this.loadingCity = false;
        });
    },
    getInstitutions() {
      this.loadingInstitutions = true;
      getRequest("/institution/")
        .then((response) => {
          this.institutions = response.institutions;
          this.loadingInstitutions = false;
        })
        .catch(() => {
          this.loadingInstitutions = false;
        });
    },
    save() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        if (this.edit === null) {
          this.close();
        } else {
          const formData = new FormData();
          if (this.logo !== null)
            formData.append(
              "logo",
              this.logo.blob,
              `logo.${this.logo.extension}`,
            );
          formData.append("institution", JSON.stringify(this.institution));
           this.emailError = null;
          if (this.edit === true) {
            postRequest
              .formData(
                "/institution/edit",
                `id=${this.institution._id}`,
                formData,
              )
              .then(() => {
                this.$emit("save");
                this.close();
              })
              .catch((error) => {
                const status = error?.response?.status ?? error?.status;
                if (status === 409) {
                  this.emailError = error?.response?.data ?? 'An institution with this email already exists.';
                   setTimeout(() => {
          this.emailError= null;
        }, 6000);
                  this.loading = false;
                } else {
                  this.$emit("error", error);
                  this.close();
                }
              });
          } else if (this.edit === false) {
           
            postRequest
              .formData("/institution/new", "", formData)
              .then(() => {
                this.$emit("save");
                this.close();
              })
              .catch((error) => {
                const status = error?.response?.status ?? error?.status;
                if (status === 409) {
                  this.emailError = error?.response?.data ?? 'An institution with this email already exists.';
                   setTimeout(() => {
          this.emailError= null;
        }, 6000);
                  this.loading = false;
                } else {
                  this.$emit("error", error);
                  this.close();
                }
              });
          } else {
            this.$emit("error", new Error("edit value is invalid"));
            this.close();
          }
        }
      }
    },
  },
};
</script>
